<div class="virtual-scroll-container" #scrollContainer>
  <div class="virtual-scroll-content" #contentContainer>
    <div
      *ngFor="let item of visibleItems$ | async; trackBy: getTrackByFn()"
      class="virtual-scroll-item"
      [ngClass]="getItemClass(item)"
      [ngStyle]="getItemStyle(item)"
      (click)="onItemClick(item)"
      (select)="onItemSelect(item)">
      
      <ng-content></ng-content>
    </div>
  </div>
  
  <!-- Loading indicator -->
  <div class="virtual-scroll-loading" *ngIf="loading">
    <div class="spinner"></div>
  </div>
  
  <!-- Empty state -->
  <div class="virtual-scroll-empty" *ngIf="items.length === 0">
    <div class="empty-message">
      <i class="material-icons">inbox</i>
      <p>Nenhum item encontrado</p>
    </div>
  </div>
</div>
